import { SelectOption } from '@invara-dev/react-base';
import { useMemo, useState } from 'react';
import { UseFormReturn } from 'react-hook-form';

export const useTravellerInputState = <T>(
  formMethods: UseFormReturn<any>,
  initialSelectOptions: SelectOption[],
  travellerKey: keyof T
) => {
  const [newTravellers, setNewTravellers] = useState<SelectOption[]>([]);

  const onNewTravellerCreated = (newOptions: SelectOption[]) => {
    setNewTravellers([...newTravellers, ...newOptions]);
    const newTravellerIds = newOptions.map((val) => val.Value as number);
    const currentTravellerIds = formMethods.getValues(travellerKey as string) as number[];
    formMethods.setValue(travellerKey as string, [...(currentTravellerIds ?? []), ...newTravellerIds]);
    formMethods.trigger();
  };

  const initialTravelers = useMemo(() => {
    const toReturn = [...newTravellers];
    if (initialSelectOptions) {
      initialSelectOptions.forEach((val) => {
        toReturn.push(val);
      });
    }
    return toReturn;
  }, [newTravellers, initialSelectOptions]);

  return { onNewTravellerCreated, initialTravelers };
};
